import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/services/api';
import { type Category, type Item, CATEGORIES, CATEGORY_LABEL } from './types';

/**
 * Form modale di creazione/edit oggetto magazzino. POST se item assente,
 * PUT se item presente. Tutti i campi opzionali sono ammessi vuoti.
 */
export function ItemForm({ item, onClose }: { item?: Item; onClose: () => void }): React.JSX.Element {
  const qc = useQueryClient();
  const [form, setForm] = useState({
    category: (item?.category ?? 'Abbigliamento') as Category,
    name: item?.name ?? '',
    quantity: item?.quantity ?? 1,
    unit: item?.unit ?? '',
    serialNumber: item?.serialNumber ?? '',
    expiry: item?.expiry ?? '',
    notes: item?.notes ?? '',
  });
  const save = useMutation({
    mutationFn: async () => {
      const body = {
        ...form, expiry: form.expiry || null, serialNumber: form.serialNumber || null,
      };
      if (item) await api.put(`/warehouse/${item.id}`, body);
      else await api.post('/warehouse', body);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['warehouse'] });
      qc.invalidateQueries({ queryKey: ['warehouse.counts'] });
      onClose();
    },
  });

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <h2>{item ? 'Modifica articolo' : 'Nuovo articolo'}</h2>
        <div className="form-group">
          <label>Categoria</label>
          <select value={form.category} onChange={e => setForm({ ...form, category: e.target.value as Category })}>
            {CATEGORIES.map(c => <option key={c} value={c}>{CATEGORY_LABEL[c].icon} {CATEGORY_LABEL[c].label}</option>)}
          </select>
        </div>
        <div className="form-group">
          <label>Nome</label>
          <input placeholder="Es. Motosega, Estintore..." value={form.name}
            onChange={e => setForm({ ...form, name: e.target.value })} />
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Quantita</label>
            <input type="number" value={form.quantity}
              onChange={e => setForm({ ...form, quantity: parseFloat(e.target.value) })} />
          </div>
          <div className="form-group">
            <label>Unita</label>
            <input placeholder="pz, lt, kg..." value={form.unit}
              onChange={e => setForm({ ...form, unit: e.target.value })} />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Matricola (opz)</label>
            <input value={form.serialNumber}
              onChange={e => setForm({ ...form, serialNumber: e.target.value })} />
          </div>
          <div className="form-group">
            <label>Scadenza (opz)</label>
            <input type="date" value={form.expiry}
              onChange={e => setForm({ ...form, expiry: e.target.value })} />
          </div>
        </div>
        <div className="form-group">
          <label>Note</label>
          <textarea value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} />
        </div>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 10 }}>
          <button onClick={onClose} className="btn-secondary">Annulla</button>
          <button onClick={() => save.mutate()} disabled={save.isPending} className="btn-success">
            💾 Salva
          </button>
        </div>
      </div>
    </div>
  );
}
